//1.引入vue
import Vue from 'vue';
//2.新创建一个vue实例
let vue = new Vue();

export default {
    getInvoiceTaskStatus: function (obj) {
        this.getInvoiceRequest(obj)
    },
    getInvoiceRequest: function (obj) {
        const that = this
        requestDat.post({
            url: "/authTaskStatus",
            data: {
                ids: [obj.id]
            }
        }).then(rep => {
            // 1.准备 2.进行中 3.成功 4.失败 5.异常 999.不存在
            if (rep) {
                let count = 0
                for (let i = 0; i < rep.length; i++) {
                    const acc = rep[i];
                    let msg = acc.taskDetailDTO && acc.taskDetailDTO.task && acc.taskDetailDTO.task.msg
                    if (acc.state == 1 || acc.state == 2) {
                        setTimeout(() => {
                            that.getInvoiceRequest(obj)
                        }, 3000);
                    } else if (acc.state == 3) {
                        vue.$notify({ title: '提示', message: `一键取票成功`, type: 'success' });
                    } else if (acc.state == 4) {
                        vue.$notify.error({ title: '提示', message: msg, });
                    } else {
                        vue.$notify({ title: '警告', message: msg, type: 'warning' });
                    }
                }
            }
        }, function () {
        });
    },
    onExportCustomer:function() {
        const that = this
        requestDat.get({
            url: "/exportCustomerStatus",
        }).then(req => {
            // 返回码 0 成功,1正在处理，其他失败
            if (req.code == 0) {
                that.onDealRequest(req,'客户')
            } else if (req.code == 1) {
                setTimeout(() => {
                    that.onExportCustomer()
                }, 1000);
            } else {
                that.onDealRequest(req, '客户')
            }
        }, function () {

        });
    },
    onDealRequest:function(result,desc) {
        vue.$notify.closeAll()
        vue.$notify({ 
            title: result.code == 0 ? `导出任务已完成` : `导出${desc}提示`,
            message: result.message,
            type: result.code == 0 ? 'success' : 'error'
        });
        if (result.code == 0) {
            window.location.href = result.url
        }
    },
    onExportAccount:function() {
        const that = this
        requestDat.get({
            url: "/exportRecordStatus",
        }).then(req => {
            // 返回码 0 成功,1正在处理，其他失败
            if (req.code == 0) {
                that.onDealRequest(req,'账户余额')
            } else if (req.code == 1) {
                setTimeout(() => {
                    that.onExportAccount()
                }, 1000);
            } else {
                that.onDealRequest(req, '账户余额')
            }
        }, function () {

        });
    },

}


// WEBPACK FOOTER //
// ./src/pages/layout/comps/pollingTask.js